import React from 'react';
import './About.css';

const About: React.FC = () => {
    return (
        <div className="about-page">
            <div className="about-container">
                <h1>About SolveSmartHome</h1>
                <p className="lead">
                    SolveSmartHome is a high-utility knowledge hub dedicated to solving smart home challenges through community consensus from r/homeautomation and r/smarthome.
                </p>

                <section className="about-section">
                    <h2>Our Mission</h2>
                    <p>
                        We believe that the internet is overloaded with information but starved for solutions. Our mission is to distill the vast knowledge found in expert communities—like Reddit, specialized forums, and technical wikis—into actionable, verified guides.
                    </p>
                </section>

                <section className="about-section">
                    <h2>How We Work</h2>
                    <p>
                        Our content is generated through a hybrid "Expert+AI" system. We use advanced algorithms to identify common pain points and community-vetted solutions, which are then curated to ensure the highest level of expertise and authoritativeness.
                    </p>
                </section>

                <section className="about-section">
                    <h2>E-E-A-T Commitment</h2>
                    <p>
                        We are committed to the principles of Experience, Expertise, Authoritativeness, and Trustworthiness. Every recommendation on this site is based on aggregated community experiences and real-world testing.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default About;
